import { render, staticRenderFns } from "./BnTabbedPage.vue?vue&type=template&id=5f39d745&"
import script from "./BnTabbedPage.vue?vue&type=script&lang=js&"
export * from "./BnTabbedPage.vue?vue&type=script&lang=js&"
import style0 from "./BnTabbedPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports